import React, { useState } from "react";
import { View, TouchableOpacity, StyleSheet, ScrollView } from "react-native";
import { NormalText } from "../../common/native";

type TSelect = {
  label: string;
  value: string;
  icon: React.ReactNode;
};

type SelectProps = {
  options: TSelect[] | [];
  onSelect: (values: string[]) => void;
  loading?: boolean;
  selectedValues: string[];
  isSaveValues?: boolean;
  userGuideHighlightIndexes?: number[] | [];
};

const Select: React.FC<SelectProps> = ({
  options,
  onSelect,
  loading = false,
  selectedValues,
  isSaveValues = true,
  userGuideHighlightIndexes = [],
}) => {
  const [selected, setSelected] = useState<string[]>(selectedValues);

  const handleSelect = (value: string) => {
    const newSelected = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];

    onSelect(newSelected);
    if (value === "change_template") return;
    if (isSaveValues) setSelected(newSelected);
  };

  return (
    <ScrollView
      horizontal={true}
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={styles.scrollViewContent}
    >
      {options.map((option, index) => (
        <View
          key={index}
          style={{
            padding: 2,
            borderWidth: 5,
            borderRadius: 3,
            borderColor: userGuideHighlightIndexes.includes(index)
              ? "#A1E3CB"
              : "transparent",
            marginBottom: "auto",
          }}
        >
          <TouchableOpacity
            disabled={loading}
            style={[
              styles.option,
              selected.includes(option.value) && styles.selectedOption,
            ]}
            onPress={() => handleSelect(option.value)}
          >
            <View style={styles.iconContainer}>{option.icon}</View>
            <NormalText text={option.label} style={styles.optionText} />
          </TouchableOpacity>
        </View>
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollViewContent: {
    flexDirection: "row",
    gap: 3,
  },
  option: {
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "#C4C6CD",
    padding: 5,
    width: 65,
    height: 65,
    justifyContent: "flex-start",
    alignItems: "center",
  },
  selectedOption: {
    backgroundColor: "#00B7F41A",
  },
  optionText: {
    fontSize: 10,
    textAlign: "center",
    fontWeight: "600",
  },
  iconContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 25,
  },
});

export default Select;
